import { render, staticRenderFns } from "./AdminSales.vue?vue&type=template&id=82cc335e&scoped=true&"
import script from "./AdminSales.vue?vue&type=script&lang=js&"
export * from "./AdminSales.vue?vue&type=script&lang=js&"
import style0 from "./AdminSales.vue?vue&type=style&index=0&id=82cc335e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cc335e",
  null
  
)

export default component.exports